import { Directive, HostBinding, Input } from '@angular/core';

@Directive({
  selector: '[psUiTooltipContent], ps-ui-tooltip-content',
})
export class TooltipContentDirective {
  @Input() psUiTooltipContent: string =
    'tooltip-content bg-dark text-white rounded-3';

  @HostBinding('class')
  @Input()
  defaultClass = 'tooltip-content bg-dark text-white rounded-3';

  constructor() {}
}
